module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./~/styled-jsx/style.js
// module id = 2
// module chunks = 0